import isEmpty from 'lodash/isEmpty'
import extractFullColorNumber from './extractFullColorNumber.util'

export default function extractFullColorNameAndNumber (colorObj = {}, withSpace = false) {
  if (isEmpty(colorObj)) return
  return `${extractFullColorNumber(colorObj, withSpace)} ${colorObj.name}`
}
